/* eslint-disable react/no-unused-state */
import * as submittedPartnerPlanFormSchema from 'schemas/forms/PartnerPlanSubmittedForm'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
import { validateAll } from 'utils/validators'
import React, { PropTypes, Component } from 'react'
import Alert from 'components/Alert'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/Form/components/TextInput'
import Checkbox from 'components/Form/components/Checkbox'
import styles from './PartnerPlanDisplayForm.scss'
import constants from 'constants'
// import moment from 'moment'
import { format } from 'date-fns'

import {
  formUpdate,
  formInit,
  formSubmit,
  formReset,
} from 'actions/forms'

class SubmittedPlanDisplayForm extends Component {
  static propTypes = {
    completeText: PropTypes.string,
    confirmation: PropTypes.bool,
    ctaText: PropTypes.string,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    handleFormSubmit: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    partnerPlan: PropTypes.object,
    selectedPlan: PropTypes.object.isRequired,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
  }
  static defaultProps = {
    data: {},
    ctaText: 'Agree',
    completeText: 'Agreed',
    submittingText: 'Submitting',
    show: false,
    confirmation: false,
    description: '',
    handleFormSubmit: null,
    id: `${constants.PARTNERPLAN.FORMS.SUBMITTED}`,
    title: '',
    partnerPlan: null,
  }

  componentWillMount() {
    const { formFields } = submittedPartnerPlanFormSchema

    const formData = {
      formFields,
      data: this.props.data || null,
    }

    this.props.dispatch(formInit(this.props.id, formData))
  }

  componentWillReceiveProps(nextProps) {
    const modalCreated = this.props.modals.finalPlanForm
    const modalChanged = modalCreated && nextProps.modals.finalPlanForm.show !== this.props.modals.finalPlanForm.show
    const modalNotVisible = modalCreated && !nextProps.modals.finalPlanForm.show
    const modalVisible = modalCreated && nextProps.modals.finalPlanForm.show
    // const dataChanged = nextProps.data !== this.props.data

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }

    if (modalChanged && modalVisible) {
      // preload data from BED if needed
      this._handleChange('role', this.props.selectedPlan.Role)
      this._handleChange('planStatus', this.props.partnerPlan.partnerPlan.planStatus)
      this._handleChange('planAgreedWithCounsellee', this.props.partnerPlan.partnerPlan.planAgreedWithCounsellee)
    }
  }

  _schema = () => {
    const obj = {}
    submittedPartnerPlanFormSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleFormSubmit = () => {
    this.setState({ submittedFiles: [] })
    const values = this.props.forms[this.props.id]
    const data = {}
    Object.keys(values).forEach((key) => {
      if (key.indexOf('_') < 0) {
        data[key] = values[key].value
      }
    })
    data.year = (this.props.selectedPlan.PlanYear ? this.props.selectedPlan.PlanYear : '')
    data.planStatus = constants.PARTNERPLAN.STATUS.AGREED
    data.planAgreedDate = `${format(new Date(), constants.DATE_FORMAT.STANDARD_ISO)}`
    this.props.handleSubmit(data)
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    const values = this.props.forms[this.props.id]
    const data = {}
    Object.keys(values).forEach((key) => {
      if (key.indexOf('_') < 0) {
        data[key] = values[key].value
      }
    })

    // Validate all the forms fields and return any errors
    const errors = validateAll(submittedPartnerPlanFormSchema.requiredFields, this.props.forms[this.props.id])
    // Check if form has errors
    if (errors.length > 0) {
      // If form has errors handle them
      errors.forEach((errObj) => {
        this._handleError(errObj, errObj.name)
      })
    } else {
      // If form has no errors, pass the serialized form field for submit and set the form to submit.
      // append or map existing data
      this.props.dispatch(formSubmit(this.props.id))
      this._handleFormSubmit()

    }
  }

  // Takes an error object for a field and updates the state accordingly
  _handleError(errorObj, stateKey) {
    // Set new state value for field and update state
    const stateValue = {
      data: {
        focus: false,
        error: (errorObj.valid) ? '' : errorObj.error,
        valid: errorObj.valid,
      },
      field: stateKey,
    }
    this._handleState(stateValue)
  }

  _handleState = (stateValue) => {
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleAutoComplete = (name, value) => {
    this._handleChange(name, value)
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }
    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleSelectChange = (name, value, selectedIndex) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
        selectedIndex,
      },
    }
    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]
    return form.planAgreedWithCounsellee.value
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      modals,
      description,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    const formHasFetched = this.props.hasFetched
    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id={constants.PARTNERPLAN.FORMS.SUBMITTED}
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <Alert type="info">
          Once you agree to the plan, you will not be able to make any changes to it. Please ensure you have reviewed the plan and are ready to proceed.
          </Alert>
          <p className={styles.content}>{description}</p>
          {form &&
          <form
            className={styles.form}
            id={this.props.id}
            noValidate="novalidate"
            onSubmit={this._handleSubmit}
          >
            <div className={styles.sectionHeader} />
            <fieldset>
              <ul>
                <Checkbox
                  {...schema.planAgreedWithCounsellee}
                  checked={!!form.planAgreedWithCounsellee.value}
                  handleChange={this._handleChange}
                />
                <TextInput
                  {...schema.planStatus}
                  handleChange={this._handleChange}
                  onBlur={this._handleValidation}
                  onFocus={this._handleFocus}
                  text={form.planStatus.value}
                />
              </ul>
            </fieldset>
            <br /><br />
            <div className={styles.footer}>
              <SubmitButton
                isLarge
                complete={this.props.forms[this.props.id]._isComplete}
                completeText={completeText} // Add validation rules
                disabled={!this.canSubmit()}
                submitting={this.props.forms[this.props.id]._isPosting}
                submittingText={submittingText}
              >
                {ctaText}
              </SubmitButton>
            </div>
          </form>
        }
        </div>
      </Modal>
    )
  }
}

export default SubmittedPlanDisplayForm



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/SubmittedPlanDisplayForm.js